import { render, staticRenderFns } from "./DatetimeFormatterColor.vue?vue&type=template&id=1cb75444&functional=true&"
import script from "./DatetimeFormatterColor.vue?vue&type=script&lang=js&"
export * from "./DatetimeFormatterColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports